import * as React from 'react';
import { Box, Flex } from '@latitude/box';
import { Text } from '@latitude/text';
import Icon from '@latitude/icon';
import { ALIGN_ITEMS, ICON_SIZE, ICON_VARIANT, COLOR, LINE_HEIGHT, FONT_WEIGHT, MARGIN } from '@latitude/core/utils/constants';
const HeroFastApply = () => /*#__PURE__*/React.createElement(Flex, {
  alignItems: ALIGN_ITEMS.CENTER,
  marginLeft: MARGIN.M24
}, /*#__PURE__*/React.createElement(Box, {
  paddingRight: "12px",
  marginBottom: "-6px"
}, /*#__PURE__*/React.createElement(Icon, {
  variant: ICON_VARIANT.STOPWATCH,
  size: ICON_SIZE.SM,
  color: COLOR.BLACK
})), /*#__PURE__*/React.createElement(Text, {
  color: COLOR.GREY75,
  fontWeight: FONT_WEIGHT.NORMAL,
  lineHeight: LINE_HEIGHT.TIGHT
}, "Apply in less", /*#__PURE__*/React.createElement("br", null), "than 10 minutes"));
export default HeroFastApply;